export const QA_NAME_RATING = 'rating'

const RATING_ITEM_SIZE_16 = 16

const RATING_ITEM_SIZE_24 = 24

export const RATING_ITEM_SIZE = {
  size16: RATING_ITEM_SIZE_16,
  size24: RATING_ITEM_SIZE_24,
}

export const RATING_LINE_LENGTH = 5
